(function() {
  'use strict';

  /* Une seule source pour la limite : l attribut pose par la section, lui-meme
     issu du reglage « Nombre maximum de palettes ». Elle valait Infinity ici
     tandis que la page affichait « / 6 » — d ou des compteurs impossibles. */
  var SC_ROOT      = document.getElementById('sampleCatalogue');
  var MAX_SAMPLES  = parseInt(SC_ROOT.dataset.max || '10', 10) || 10;
  var SAMPLE_PRICE = parseInt(SC_ROOT.dataset.price || '8', 10);

  window.sampleCart = [];
  var activeMatiere = 'all';
  var searchQuery   = '';
  var currentGroup  = null; // groupe ouvert dans le drawer

  console.log('%c[SampleCatalogue] Initialisation — palettes', 'color:#888;font-weight:bold');
  console.log('[SampleCatalogue] Max:', MAX_SAMPLES, '| Prix unitaire:', SAMPLE_PRICE + '€');

  /* ══ UTILS ══ */

  /* Filet de securite sur les images redimensionnees.

     Certains fichiers de la bibliotheque sont servis tels quels par le CDN
     mais renvoient 404 des qu on leur ajoute un parametre de taille : le
     fichier n a jamais ete traite par le pipeline image de Shopify. La vraie
     correction est de le re-televerser dans Contenu > Fichiers, mais en
     attendant mieux vaut une image lourde qu un trou dans la grille.

     Un seul ecouteur en phase de CAPTURE : error ne remonte pas, il ne serait
     jamais vu en phase de bouillonnement. Ainsi pose, il couvre aussi les
     images ecrites par innerHTML, sans avoir a toucher chaque endroit. */
  function urlSansTaille(src) {
    return String(src || '')
      .replace(/([?&])width=\d+&?/, '$1')
      .replace(/([?&])height=\d+&?/, '$1')
      .replace(/[?&]$/, '');
  }

  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.scOriginal) return;
    if (!img.closest || !img.closest('#sampleCatalogue, .sc-drawer, .sc-detail, .sc-bar, .sc-specs-sheet')) return;

    var brut = urlSansTaille(img.src);
    if (!brut || brut === img.src) return;

    img.dataset.scOriginal = '1';
    img.src = brut;
  }, true);

  // Redimensionne une URL Shopify CDN quelle que soit la width actuelle
  function resizeSwatch(url, targetWidth) {
    if (!url) return '';
    // Ajouter https: si protocol-relative
    var src = url.indexOf('//') === 0 ? 'https:' + url : url;
    // Remplacer width=N existant
    if (src.indexOf('width=') !== -1) {
      return src.replace(/width=\d+/, 'width=' + targetWidth);
    }
    // Ajouter width= si absent
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + targetWidth;
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function buildId(tex, groupName) {
    return (groupName + '__' + (tex.name || '') + '__' + (tex.color || '')).replace(/\s+/g,'_');
  }

  // Extrait la matière depuis le nom de groupe "Abriamo – Velours côtelé" → "Velours côtelé"
  function extractMatiere(groupName) {
    var sep = groupName.indexOf(' – ');
    if (sep === -1) sep = groupName.indexOf(' - ');
    return sep !== -1 ? groupName.slice(sep + 3).trim() : null;
  }

  // Extrait le nom court de palette "Abriamo – Velours côtelé" → "Abriamo"
  function extractPaletteName(groupName) {
    var sep = groupName.indexOf(' – ');
    if (sep === -1) sep = groupName.indexOf(' - ');
    return sep !== -1 ? groupName.slice(0, sep).trim() : groupName;
  }

  /* ══ PANIER ══ */
  function cartContains(id) {
    return window.sampleCart.some(function(i) { return i.id === id; });
  }

  // Palette = 1 item dans le panier, id = 'palette__' + group.group
  function addPaletteToCart(group) {
    var pid = 'palette__' + group.group;
    if (cartContains(pid)) { showToast('Déjà dans la sélection'); return; }
    if (window.sampleCart.length >= MAX_SAMPLES) {
      showToast('Maximum ' + MAX_SAMPLES + ' nuanciers');
      console.warn('[SampleCart] Limite atteinte');
      return;
    }
    var paletteName = extractPaletteName(group.group);
    // Swatch = premier item valide
    var firstSwatch = '';
    for (var i = 0; i < group.items.length; i++) {
      if (group.items[i].swatch) { firstSwatch = group.items[i].swatch; break; }
    }
    // Stocker jusqu'à 4 swatches pour le mini-éventail
    var swatchList = [];
    group.items.forEach(function(t) { if (t.swatch && swatchList.length < 4) swatchList.push(t.swatch); });
    var item = { id: pid, name: paletteName, color: (group.items.length + ' coloris'), group: group.group, swatch: firstSwatch, swatches: swatchList };
    window.sampleCart.push(item);
    console.log('[SampleCart] ➕ Palette:', paletteName);
    console.log('[SampleCart] Panier:', JSON.parse(JSON.stringify(window.sampleCart)));
    updatePaletteCard(group.group, true);
    updateCardAddBtn(group.group);
    refreshDrawerAtcBtn(group.group);
    updateCartUI();
    showToast('Nuancier ajouté');
    // Fermer le drawer après ajout
    if (currentGroup && currentGroup.group === group.group) closeDrawer();
  }

  function removePaletteFromCart(groupName) {
    var pid = 'palette__' + groupName;
    window.sampleCart = window.sampleCart.filter(function(i) { return i.id !== pid; });
    console.log('[SampleCart] ➖ Palette:', groupName);
    console.log('[SampleCart] Panier:', JSON.parse(JSON.stringify(window.sampleCart)));
    updatePaletteCard(groupName, false);
    updateCardAddBtn(groupName);
    refreshDrawerAtcBtn(groupName);
    updateCartUI();
  }

  function clearCart() {
    var groups = window.sampleCart.map(function(i) { return i.group; });
    window.sampleCart = [];
    groups.forEach(function(g) { updatePaletteCard(g, false); updateCardAddBtn(g); });
    refreshDrawerAtcBtn(currentGroup ? currentGroup.group : null);
    updateCartUI();
    console.log('[SampleCart] 🗑 Vidé');
  }

  function updatePaletteCard(groupName, added) {
    var card = document.querySelector('.sc-palette-card[data-group="' + CSS.escape(groupName) + '"]');
    if (!card) return;
    card.classList.toggle('has-selected', added);
    var badge = card.querySelector('.sc-palette-badge');
    if (badge) badge.textContent = added ? 'Ajoutée' : '';
  }

  function updateCardAddBtn(groupName) {
    var card = document.querySelector('.sc-palette-card[data-group="' + CSS.escape(groupName) + '"]');
    if (!card) return;
    var btn = card.querySelector('.sc-palette-add-btn');
    if (!btn) return;
    var isAdded = cartContains('palette__' + groupName);
    btn.classList.toggle('is-added', isAdded);
  }

  function refreshDrawerAtcBtn(groupName) {
    if (!groupName || !currentGroup || currentGroup.group !== groupName) return;
    var footer = document.getElementById('scDrawerFooter');
    if (!footer) return;
    var isAdded = cartContains('palette__' + groupName);
    var btn = footer.querySelector('.sc-drawer-atc');
    if (!btn) return;
    btn.className = 'sc-drawer-atc' + (isAdded ? ' is-added' : '');
    btn.innerHTML = isAdded
      ? '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 5,9.5 10.5,2.5"/></svg> Nuancier ajouté, retirer'
      : 'Ajouter ce nuancier';
    // Ré-attacher le listener
    var grp = currentGroup;
    btn.onclick = function() {
      if (cartContains('palette__' + grp.group)) { removePaletteFromCart(grp.group); }
      else { addPaletteToCart(grp); }
    };
  }

  /* ══ UPDATE UI BARRE ══ */
  function updateCartUI() {
    var n   = window.sampleCart.length;
    var bar = document.getElementById('scBar');
    if (bar) bar.classList.toggle('is-visible', n > 0);

    var countEl = document.getElementById('scCartCount');
    if (countEl) countEl.textContent = n;

    var totalEl = document.getElementById('scBarTotal');
    if (totalEl) totalEl.textContent = (n * SAMPLE_PRICE) + ' €';

    var cardsEl = document.getElementById('scBarCards');
    if (!cardsEl) return;

    if (n === 0) {
      cardsEl.innerHTML = '<p class="sc-bar-hint">Ajoutez des nuanciers depuis le catalogue</p>';
      return;
    }

    var compact = n > 5; // au-delà de 5 palettes : on retire les previews pour gagner de la place
    cardsEl.innerHTML = window.sampleCart.map(function(item) {
      var fanHtml = '';
      if (!compact) {
        var swatches = item.swatches || (item.swatch ? [item.swatch] : []);
        // Mini éventail : max 3 swatches
        var fanItems = swatches.slice(0, 3);
        var nFan = fanItems.length;
        var spread = nFan > 1 ? 40 : 0;
        var startA = -spread / 2;
        var stepA  = nFan > 1 ? spread / (nFan - 1) : 0;
        fanHtml = '<div class="sc-bar-fan">' + fanItems.map(function(sw, idx) {
          var t = resizeSwatch(sw, 100);
          var angle = startA + stepA * idx;
          var z = idx + 1;
          return '<img class="sc-bar-fan-swatch" src="' + escHtml(t) + '" loading="lazy"'
            + ' style="z-index:' + z + ';transform:translateX(-50%) rotate(' + angle + 'deg);">';
        }).join('') + '</div>';
      }

      return '<div class="sc-bar-card' + (compact ? ' is-compact' : '') + '" data-id="' + escHtml(item.id) + '">'
        + fanHtml
        + '<div class="sc-bar-card-info">'
        + '<div class="sc-bar-card-name">' + escHtml(item.name) + '</div>'
        + '<div class="sc-bar-card-group">' + escHtml(item.color) + '</div>'
        + '</div>'
        + '<button class="sc-bar-card-remove" data-group="' + escHtml(item.group) + '" aria-label="Retirer">'
        + '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">'
        + '<line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/>'
        + '</svg></button></div>';
    }).join('');

    /* La croix appelait removeFromCart(), qui n a jamais existe : chaque clic
       levait une ReferenceError et la palette restait dans la barre. Le panier
       range des PALETTES (id « palette__<groupe> »), la suppression se fait
       donc par nom de groupe. */
    cardsEl.querySelectorAll('.sc-bar-card-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        removePaletteFromCart(btn.getAttribute('data-group'));
      });
    });

    // Mobile : pastilles palette
    var mobileEl = document.getElementById('scBarMobilePalettes');
    var mobileTotalEl = document.getElementById('scBarMobileTotal');
    if (mobileTotalEl) mobileTotalEl.textContent = (n * SAMPLE_PRICE) + ' €';
    if (mobileEl) {
      if (n === 0) {
        mobileEl.innerHTML = '<span class="sc-bar-mobile-hint">Aucun nuancier sélectionné</span>';
      } else {
        mobileEl.innerHTML = window.sampleCart.map(function(item) {
          var sw = (item.swatches && item.swatches[0]) ? resizeSwatch(item.swatches[0], 60) : '';
          return '<div class="sc-bar-mobile-pill">'
            + (sw ? '<img class="sc-bar-mobile-swatch" src="' + escHtml(sw) + '" alt="">' : '')
            + escHtml(item.name)
            + '<button class="sc-bar-mobile-remove" data-group="' + escHtml(item.group) + '" aria-label="Retirer">'
            + '<svg viewBox="0 0 8 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">'
            + '<line x1="1" y1="1" x2="7" y2="7"/><line x1="7" y1="1" x2="1" y2="7"/>'
            + '</svg></button></div>';
        }).join('');
        mobileEl.querySelectorAll('.sc-bar-mobile-remove').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.stopPropagation();
            removePaletteFromCart(btn.getAttribute('data-group'));
          });
        });
      }
    }
  }

/* ══ TOAST ══ */
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('scToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() { t.classList.remove('show'); }, 2200);
  }

  /* ══ DRAWER ══ */
  function openDrawer(group) {
    currentGroup = group;
    var paletteName = extractPaletteName(group.group);
    var matiere     = extractMatiere(group.group);

    document.getElementById('scDrawerTitle').textContent   = paletteName;
    document.getElementById('scDrawerEyebrow').textContent = matiere || 'Nuancier';
    document.getElementById('scDrawerCount').textContent   = group.items.length + ' coloris';

    // Image "Spécifications textile" du GROUPE en débordement à gauche (si renseignée)
    var specsWrap = document.getElementById('scDrawerSpecs');
    if (specsWrap) {
      specsWrap.classList.remove('is-visible'); // reset pour re-jouer la transition
      if (group.specs_html) {
        document.getElementById('scDrawerSpecsHtml').innerHTML = group.specs_html;
        // ouverture différée : la carte glisse un peu après le drawer
        setTimeout(function(){ specsWrap.classList.add('is-visible'); }, 420);
      } else {
        document.getElementById('scDrawerSpecsHtml').innerHTML = '';
      }
      // Bouton "Voir les détails complets" → PDF technical card (nouvel onglet)
      var specsBtn = document.getElementById('scDrawerSpecsBtn');
      if (specsBtn) {
        if (group.pdf) {
          specsBtn.href = group.pdf;
          specsBtn.classList.add('is-visible');
        } else {
          specsBtn.removeAttribute('href');
          specsBtn.classList.remove('is-visible');
        }
      }
    }

    // "i" (mobile) + bottom-sheet specs (même contenu, présentation bottom sur mobile)
    var infoBtn  = document.getElementById('scSpecsInfoBtn');
    var sheetHtml = document.getElementById('scSpecsSheetHtml');
    var sheetBtn = document.getElementById('scSpecsSheetBtn');
    if (group.specs_html) {
      if (infoBtn) infoBtn.classList.add('is-available');
      if (sheetHtml) sheetHtml.innerHTML = group.specs_html;
    } else {
      if (infoBtn) infoBtn.classList.remove('is-available');
      if (sheetHtml) sheetHtml.innerHTML = '';
    }
    if (sheetBtn) {
      if (group.pdf) { sheetBtn.href = group.pdf; sheetBtn.classList.add('is-visible'); }
      else { sheetBtn.removeAttribute('href'); sheetBtn.classList.remove('is-visible'); }
    }

    // Construire la grille de coloris
    var body = document.getElementById('scDrawerBody');
    body.innerHTML = '';
    var grid = document.createElement('div');
    grid.className = 'sc-coloris-grid';

    group.items.forEach(function(tex) {
      if (!tex.swatch) return;
      var label = [tex.color, tex.name].filter(Boolean).join(' ');
      var thumb = resizeSwatch(tex.swatch, 300);

      var card = document.createElement('div');
      card.className  = 'sc-coloris-card';
      card.dataset.id = tex.id;
      if (cartContains(tex.id)) card.classList.add('is-added');

      card.innerHTML =
        '<div style="overflow:hidden;position:relative;">'
        + '<img class="sc-coloris-img" src="' + escHtml(thumb) + '" alt="' + escHtml(label) + '" loading="lazy">'
        + '</div>'
        + '<div class="sc-coloris-body">'
        + '<div class="sc-coloris-info">'
        + '<div class="sc-coloris-name">' + escHtml(tex.name || tex.color || '') + '</div>'
        + (tex.color ? '<div class="sc-coloris-color">' + escHtml(tex.color) + '</div>' : '')
        + '</div></div>';

      card.addEventListener('click', function() { openDetail(tex, group); });
      grid.appendChild(card);
    });

    body.appendChild(grid);

    // Footer ATC palette
    var footer = document.getElementById('scDrawerFooter');
    var isAdded = cartContains('palette__' + group.group);
    footer.innerHTML =
      '<button class="sc-drawer-atc ' + (isAdded ? 'is-added' : '') + '" id="scDrawerAtcBtn">'
      + (isAdded
        ? '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 5,9.5 10.5,2.5"/></svg> Nuancier ajouté, retirer'
        : 'Ajouter ce nuancier')
      + '</button>';

    document.getElementById('scDrawerAtcBtn').addEventListener('click', function() {
      if (cartContains('palette__' + group.group)) {
        removePaletteFromCart(group.group);
      } else {
        addPaletteToCart(group);
      }
    });

    document.getElementById('scDrawer').classList.add('is-open');

    // Scroll JS sur desktop : wheel sur le drawer → scroll le body du drawer
    var drawerEl = document.getElementById('scDrawer');
    var bodyEl   = document.getElementById('scDrawerBody');
    if (!drawerEl._wheelBound) {
      drawerEl._wheelBound = true;
      drawerEl.addEventListener('wheel', function(e) {
        e.preventDefault();
        e.stopPropagation();
        bodyEl.scrollTop += e.deltaY;
      }, { passive: false });
    }
    document.getElementById('scOverlay').style.display = 'block';
    // Bloquer le scroll body sans layout shift
    var scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.dataset.scrollY = scrollY;
    console.log('[SampleCatalogue] Drawer ouvert — palette:', paletteName);
  }

  function openSpecsSheet() {
    document.getElementById('scSpecsSheet').classList.add('is-open');
    document.getElementById('scSpecsSheetOverlay').classList.add('is-open');
  }
  function closeSpecsSheet() {
    var s = document.getElementById('scSpecsSheet');
    var o = document.getElementById('scSpecsSheetOverlay');
    if (s) s.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
  }

  function closeDrawer() {
    closeSpecsSheet();
    var sp = document.getElementById('scDrawerSpecs');
    if (sp) sp.classList.remove('is-visible');
    document.getElementById('scDrawer').classList.remove('is-open');
    document.getElementById('scOverlay').style.display = 'none';
    var scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
    currentGroup = null;
    console.log('[SampleCatalogue] Drawer fermé');
  }

  /* ══ TEXTURE DETAIL (zoom coloris) ══ */
  function openDetail(tex, group) {
    if (!tex || !tex.swatch) return;
    var fullLabel = [tex.color, tex.name].filter(Boolean).join(' ');
    var img  = document.getElementById('scDetailImg');
    img.src  = resizeSwatch(tex.swatch, 1000);
    img.alt  = fullLabel;
    document.getElementById('scDetailName').textContent = fullLabel;
    var gammeEl = document.getElementById('scDetailGamme');
    if (group && group.gamme) {
      gammeEl.textContent = 'Gamme ' + group.gamme;
      gammeEl.style.display = '';
    } else {
      gammeEl.textContent = '';
      gammeEl.style.display = 'none';
    }
    // Bouton "Ajouter cette palette" — même fonction que le drawer global
    var atc = document.getElementById('scDetailAtcBtn');
    if (atc) {
      var syncDetailAtc = function() {
        var isAdded = cartContains('palette__' + group.group);
        atc.className = 'sc-drawer-atc' + (isAdded ? ' is-added' : '');
        atc.innerHTML = isAdded
          ? '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 5,9.5 10.5,2.5"/></svg> Nuancier ajouté, retirer'
          : 'Ajouter ce nuancier';
      };
      atc.onclick = function() {
        if (cartContains('palette__' + group.group)) { removePaletteFromCart(group.group); }
        else { addPaletteToCart(group); }
        syncDetailAtc();
      };
      syncDetailAtc();
    }

    // 2e "i" (mobile) dans le detail → ouvre le bottom-sheet specs du groupe
    var detailInfo = document.getElementById('scDetailInfoBtn');
    if (detailInfo) {
      if (group.specs_html) detailInfo.classList.add('is-available');
      else detailInfo.classList.remove('is-available');
    }

    document.getElementById('scDetail').classList.add('is-open');
  }

  function closeDetail() {
    document.getElementById('scDetail').classList.remove('is-open');
  }

  /* ══ FILTRES ══ */
  function applyFilters() {
    var q      = searchQuery.trim().toLowerCase();
    var cards  = document.querySelectorAll('.sc-palette-card');
    var noRes  = document.getElementById('scNoResult');
    var total  = 0;

    cards.forEach(function(card) {
      var groupName   = card.dataset.group || '';
      var matiere     = (extractMatiere(groupName) || '').toLowerCase();
      var paletteName = extractPaletteName(groupName).toLowerCase();

      var matiereOk = activeMatiere === 'all' || normMatiere(extractMatiere(groupName)) === activeMatiere;
      var searchOk  = !q || paletteName.indexOf(q) !== -1 || groupName.toLowerCase().indexOf(q) !== -1;
      var visible   = matiereOk && searchOk;

      card.style.display = visible ? '' : 'none';
      if (visible) total++;
    });

    if (noRes) noRes.style.display = total === 0 ? 'block' : 'none';
    console.log('[SampleCatalogue] Filtre matière="' + activeMatiere + '" search="' + searchQuery + '" → ' + total + ' palette(s)');
  }


  // Table de regroupement des matières
  var MATIERE_MAP = {
    // Velours côtelé : côtelé + gros côtelé uniquement
    'velours côtelé':        'Velours côtelé',
    'velours cotelé':        'Velours côtelé',
    'velours cotele':        'Velours côtelé',
    'velours côtelé large':  'Velours côtelé',
    'velours cotelé large':  'Velours côtelé',
    'velours gros côtelé':   'Velours côtelé',
    'velours gros cotelé':   'Velours côtelé',
    'velours gros cotele':   'Velours côtelé',
    // Velours : velours uni, tricot, chenille velours
    'velours':               'Velours',
    'velours tricot':        'Velours',
    'velours chenille':      'Velours',
    // Tissu bouclé
    'tissu bouclé':          'Tissu bouclé',
    'tissu boucle':          'Tissu bouclé',
    'tissu bouclé nuageux':  'Tissu bouclé',
    'tissu boucle nuageux':  'Tissu bouclé',
    // Tissés & Chenille : chenille, tressé, natté, tissé doux
    'tissu chenille':        'Tissés & Chenille',
    'tissu tressé':          'Tissés & Chenille',
    'tissu tresse':          'Tissés & Chenille',
    'tissu tressé chiné':    'Tissés & Chenille',
    'tissu tresse chine':    'Tissés & Chenille',
    'tissu natté':           'Tissés & Chenille',
    'tissu natte':           'Tissés & Chenille',
    'tissu tissé doux':      'Tissés & Chenille',
    'tissu tisse doux':      'Tissés & Chenille',
  };

  function normMatiere(m) {
    if (!m) return null;
    var key = m.toLowerCase().trim();
    return MATIERE_MAP[key] || m;
  }

  /* ══ RENDU PILLS MATIÈRE ══ */
  function renderMatieresPills(groups) {
    var container = document.getElementById('scMatierePills');
    if (!container) return;

    // Collecter les matières normalisées uniques
    var matieres = [];
    groups.forEach(function(g) {
      var m = normMatiere(extractMatiere(g.group));
      if (m && matieres.indexOf(m) === -1) matieres.push(m);
    });

    if (matieres.length < 2) return;

    var allBtn = document.createElement('button');
    allBtn.className   = 'sc-pill active';
    allBtn.dataset.mat = 'all';
    allBtn.textContent = 'Tous';
    container.appendChild(allBtn);

    matieres.forEach(function(m) {
      var btn = document.createElement('button');
      btn.className   = 'sc-pill';
      btn.dataset.mat = m;
      btn.textContent = m;
      container.appendChild(btn);
    });

    container.addEventListener('click', function(e) {
      var btn = e.target.closest('.sc-pill');
      if (!btn) return;
      activeMatiere = btn.dataset.mat;
      console.log('[SampleCatalogue] Matière active:', activeMatiere);
      container.querySelectorAll('.sc-pill').forEach(function(b) { b.classList.toggle('active', b === btn); });
      applyFilters();
    });
  }

  /* ══ RENDU GRILLE PALETTES ══ */
  function renderPalettes() {
    var grid    = document.getElementById('scPaletteGrid');
    var loading = document.getElementById('scLoading');

    // DOM ou TEXTURES pas encore prêts → retry
    if (!grid || !window.TEXTURES || window.TEXTURES.length === 0) {
      console.log('[SampleCatalogue] DOM ou TEXTURES pas encore prêt, retry…');
      setTimeout(renderPalettes, 100);
      return;
    }

    /* Surface de CHOIX : les gammes cochees « Masquer de la personnalisation »
       n ont rien a faire dans un catalogue d echantillons a commander. */
    var palettes = window.TEXTURES_PERSO || window.TEXTURES;

    /* Gammes retirees des NUANCIERS seulement (29/09/2026, demande de
       l utilisateur) : elles restent choisissables dans le tiroir de la fiche,
       on ne vend simplement plus leur nuancier. Rapprochement sur le nom avant
       « - » : Coco existe en deux blocs (« Coco » et « Coco - Tissu chenille
       texture »). hide_perso ne convenait pas : il les aurait aussi retirees
       du tiroir. */
    var SANS_NUANCIER = ['nube', 'coco'];
    palettes = palettes.filter(function (g) {
      var nom = String(g.group || '').split(' - ')[0].trim().toLowerCase();
      return SANS_NUANCIER.indexOf(nom) === -1;
    });

    console.log('[SampleCatalogue] window.TEXTURES chargé —', palettes.length, 'palette(s) proposables sur', window.TEXTURES.length);
    palettes.forEach(function(g) {
      console.log('  · "' + g.group + '" —', (g.items || []).length, 'coloris');
    });

    if (loading) loading.style.display = 'none';

    try {

    // Assigner IDs — sur la liste complete : le panier peut contenir un id
    // pose avant qu une gamme ne soit retiree.
    window.TEXTURES.forEach(function(group) {
      (group.items || []).forEach(function(tex) {
        if (!tex.id) tex.id = buildId(tex, group.group);
      });
    });

    renderMatieresPills(palettes);

    palettes.forEach(function(group) {
      if (!group.items || group.items.length === 0) return;

      var paletteName = extractPaletteName(group.group);
      var matiere     = extractMatiere(group.group);

      // Swatches pour l eventail (max 5)
      var allSwatches = group.items.filter(function(t) { return !!t.swatch; });
      /* L eventail montre les coloris REELS, jamais plus.
         Il completait auparavant jusqu a trois en repetant les memes images
         « pour du volume » : une gamme d un seul coloris s affichait donc en
         triple, et la carte annoncait une richesse qui n existe pas. */
      var fanItems = allSwatches.slice(0, 5);

      var card = document.createElement('div');
      card.className     = 'sc-palette-card';
      card.dataset.group = group.group;

      // Preview éventail
      var preview = document.createElement('div');
      preview.className = 'sc-palette-preview';

      var n = fanItems.length;
      // Angles : répartis autour de 0°, spread total ~80°.
      // Un coloris seul reste droit : incliné, il aurait l air d un accident.
      var spread = n > 1 ? Math.min(80, n * 18) : 0;
      var startAngle = -spread / 2;
      var step = n > 1 ? spread / (n - 1) : 0;
      // translateX de base : centré
      var baseX = -28; // 56%/2 = 28 → centré sur left:50%

      fanItems.forEach(function(tex, idx) {
        var thumb = resizeSwatch(tex.swatch, 300);
        var img = document.createElement('img');
        img.src = thumb; img.alt = tex.name || ''; img.loading = 'lazy';
        img.className = 'sc-fan-swatch';
        var angle = startAngle + step * idx;
        img.style.zIndex = idx + 1;
        img.style.transform = 'translateX(' + baseX + '%) rotate(' + angle + 'deg)';
        // hover : écarter légèrement
        var hoverAngle = angle * 1.25;
        img.addEventListener('mouseenter', function() {
          preview.querySelectorAll('.sc-fan-swatch').forEach(function(s, i) {
            var a = startAngle + step * i;
            s.style.transform = 'translateX(' + baseX + '%) rotate(' + (a * 1.2) + 'deg) translateY(-4%)';
          });
        });
        preview.appendChild(img);
      });

      preview.addEventListener('mouseleave', function() {
        preview.querySelectorAll('.sc-fan-swatch').forEach(function(img, idx) {
          var angle = startAngle + step * idx;
          img.style.transform = 'translateX(' + baseX + '%) rotate(' + angle + 'deg)';
        });
      });

      // Badge "Ajoutée"
      var badge = document.createElement('span');
      badge.className = 'sc-palette-badge';
      preview.appendChild(badge);

      card.appendChild(preview);

      // Infos
      var info = document.createElement('div');
      info.className = 'sc-palette-info';
      info.innerHTML =
        '<div>'
        + '<div class="sc-palette-name">' + escHtml(paletteName) + '</div>'
        + (matiere ? '<div class="sc-palette-sub">' + escHtml(matiere) + ' — ' + group.items.length + ' coloris</div>' : '<div class="sc-palette-sub">' + group.items.length + ' coloris</div>')
        + '</div>'
        + '<button class="sc-palette-add-btn" aria-label="Ajouter la palette">'
        + '<svg class="sc-icon-plus" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><line x1="6" y1="1" x2="6" y2="11"/><line x1="1" y1="6" x2="11" y2="6"/></svg>'
        + '<svg class="sc-icon-check" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><polyline points="1.5,6 5,9.5 10.5,2.5"/></svg>'
        + '</button>';
      card.appendChild(info);

      // Bouton + : ajouter/retirer la palette sans ouvrir le drawer
      (function(grp) {
        var addBtn = info.querySelector('.sc-palette-add-btn');
        addBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          var pid = 'palette__' + grp.group;
          if (cartContains(pid)) { removePaletteFromCart(grp.group); }
          else { addPaletteToCart(grp); }
          // Mettre à jour l'état visuel du bouton
          updateCardAddBtn(grp.group);
        });
      })(group);

      // Clic carte → ouvrir drawer
      card.addEventListener('click', function() { openDrawer(group); });

      grid.appendChild(card);
    });

    console.log('[SampleCatalogue] Grille palettes rendue ✓');
    applyFilters();

    } catch(err) {
      console.error('[SampleCatalogue] ❌ Erreur rendu palettes :', err);
      console.error('[SampleCatalogue] Stack :', err.stack);
    }
  }

  /* ══ EVENTS ══ */
  // Lancer avec délai pour laisser le DOM et window.TEXTURES se stabiliser
  setTimeout(function() { renderPalettes(); }, 800);

  document.addEventListener('DOMContentLoaded', function() {

    // Recherche
    var searchEl = document.getElementById('scSearch');
    if (searchEl) {
      searchEl.addEventListener('input', function() {
        searchQuery = this.value;
        applyFilters();
      });
    }

    // Fermer drawer
    document.getElementById('scDrawerClose').addEventListener('click', closeDrawer);
    document.getElementById('scOverlay').addEventListener('click', function() { closeDetail(); closeDrawer(); });

    // Bottom-sheet specs (mobile) : "i" ouvre, overlay ferme
    var specsInfoBtn = document.getElementById('scSpecsInfoBtn');
    if (specsInfoBtn) specsInfoBtn.addEventListener('click', openSpecsSheet);
    var detailInfoBtn = document.getElementById('scDetailInfoBtn');
    if (detailInfoBtn) detailInfoBtn.addEventListener('click', openSpecsSheet);
    var specsSheetOverlay = document.getElementById('scSpecsSheetOverlay');
    if (specsSheetOverlay) specsSheetOverlay.addEventListener('click', closeSpecsSheet);

    // Texture detail (zoom coloris)
    var dBack  = document.getElementById('scDetailBack');
    var dClose = document.getElementById('scDetailClose');
    if (dBack)  dBack.addEventListener('click', closeDetail);
    if (dClose) dClose.addEventListener('click', function() { closeDetail(); closeDrawer(); });

    // Vider
    document.getElementById('scRecapClear').addEventListener('click', function() {
      if (!window.sampleCart.length) return;
      clearCart();
      showToast('Sélection vidée');
    });

    // ATC
    // ATC mobile
    var atcMobile = document.getElementById('scRecapAtcMobile');
    if (atcMobile) atcMobile.addEventListener('click', function() {
      document.getElementById('scRecapAtc').click();
    });

    document.getElementById('scRecapAtc').addEventListener('click', function() {
      if (!window.sampleCart.length) return;

      var palettes   = window.sampleCart.map(function(i) { return extractPaletteName(i.group); });
      var totalPrice = window.sampleCart.length * SAMPLE_PRICE;
      var paletteStr = palettes.join(', ');

      console.log('══════════════════════════════════');
      console.log('[SampleCart] ✅ INJECTION SHOPIFY');
      console.log('  Prix :', totalPrice + ' €');
      console.log('  Palettes :', paletteStr);
      console.log('══════════════════════════════════');

      injectAndSubmit(totalPrice, paletteStr);
    });

  /* ══════════════════════════════════
     INJECTION SHOPIFY — PWYW + Champ custom + ATC
  ══════════════════════════════════ */
  /* ══ LOADER ══ */
  var loaderMessages = [
    'Vérification de votre sélection…',
    'Application du prix…',
    'Enregistrement des nuanciers choisis…',
    'Ajout au panier en cours…',
    'Finalisation de la commande…',
    'REDIRECTION VERS LE PANIER…',
  ];
  var loaderTimer = null;

  function showLoader(palettes, totalPrice) {
    var overlay  = document.getElementById('scLoaderOverlay');
    var titleEl  = document.getElementById('scLoaderTitle');
    var palEl    = document.getElementById('scLoaderPalettes');
    if (!overlay) return;

    // Remplir les infos
    if (palEl)   palEl.textContent   = palettes;
    if (titleEl) titleEl.textContent = totalPrice + ' € — ' + (palettes.split(',').length) + ' nuancier' + (palettes.split(',').length > 1 ? 's' : '');
    overlay.classList.add('is-active');

    // Séquence de progression
    var step = 0;
    // Délais entre chaque message pour couvrir ~12s au total
    var stepDelays = [0, 2000, 2000, 2200, 2300, 2500];

    function nextStep() {
      if (step >= loaderMessages.length) return;
      var msg = loaderMessages[step++];
      if (titleEl) titleEl.textContent = msg;
      console.log('[SampleLoader]', msg);
      if (step < loaderMessages.length) {
        loaderTimer = setTimeout(nextStep, stepDelays[step - 1] || 2000);
      }
    }
    setTimeout(nextStep, 300);
  }

  function hideLoader() {
    var overlay = document.getElementById('scLoaderOverlay');
    if (overlay) overlay.classList.remove('is-active');
    if (loaderTimer) clearTimeout(loaderTimer);
  }

  function waitForEl(selector, callback, maxTries) {
    maxTries = maxTries || 30;
    var el = document.querySelector(selector);
    if (el) { callback(el); return; }
    if (maxTries <= 0) {
      console.warn('[SampleCart] ⚠ Élément introuvable :', selector);
      return;
    }
    setTimeout(function() { waitForEl(selector, callback, maxTries - 1); }, 200);
  }

  function fireInputEvents(el) {
    ['input', 'change', 'blur'].forEach(function(ev) {
      el.dispatchEvent(new Event(ev, { bubbles: true }));
    });
  }

  function injectAndSubmit(price, paletteStr) {
    showLoader(paletteStr, price);

    // Étape 1 : injecter le prix dans le champ PWYW (avec retry)
    waitForEl('#input__price', function(priceInput) {
      console.log('[SampleCart] Étape 1 — Injection prix :', price);
      priceInput.value = price;
      fireInputEvents(priceInput);

      // Étape 2 : injecter les palettes dans le champ properties[Palettes]
      setTimeout(function() {
        waitForEl('input[name="properties[Palettes]"]', function(propInput) {
          console.log('[SampleCart] Étape 2 — Injection palettes :', paletteStr);
          propInput.value = paletteStr;
          fireInputEvents(propInput);

          // Étape 3 : cliquer le vrai bouton ATC Shopify
          setTimeout(function() {
            var atcBtn = document.querySelector('.eo-sh-addToCart, button[type="submit"][name="add"]');
            if (!atcBtn) {
              console.warn('[SampleCart] ⚠ Bouton ATC Shopify introuvable');
              showToast('Erreur : bouton panier introuvable');
              return;
            }
            console.log('[SampleCart] Étape 3 — Clic ATC Shopify :', atcBtn);
            atcBtn.click();
            // Le loader reste affiché jusqu'à la redirection Shopify
          }, 300);

        });
      }, 300);
    });
  }

  });

})();
